import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, LinearProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import { Typography } from '@totalsoft/rocket-ui';

const BoxWithRoot = styled(Box)(({ theme }) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2)
    }
  }
}));

const AssetHierarchyImportStatus = ({ status }) => {
  const { t } = useTranslation();

  return status ? (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <BoxWithRoot>
          <LinearProgress variant='determinate' value={status.progress} />
        </BoxWithRoot>
      </Grid>
      <Grid item xs={11}>
        <Typography variant='caption' display='block' gutterBottom>
          {t(`AssetHierarchy.Import.Status.${status.statusCode}`, { ...status.statusData, message: status.message } || {})}
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Grid container spacing={1} justifyContent='flex-end'>
          <Typography variant='caption' display='block' gutterBottom>{`${status.progress}%`}</Typography>
        </Grid>
      </Grid>
    </Grid>
  ) : (
    ''
  );
};

AssetHierarchyImportStatus.propTypes = {
  status: PropTypes.object
};

export default AssetHierarchyImportStatus;
